import React from 'react';
import { SendProposalStatus } from '../../../core';

type ProposalApprovalModalProps = {
  setStatusModalOpen: (state: { isOpen?: boolean; status?: SendProposalStatus }) => void;
  updating: boolean;
  changeStatus: () => void;
};

const ProposalApprovalModal: React.FC<ProposalApprovalModalProps> = ({ setStatusModalOpen, updating, changeStatus }) => {
  return (
    <>
      <div
        className="modal fade show in"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ zIndex: 1052 }}
      >
        <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
          <div className="modal-content rounded-0">
            <div className="modal-body text-center">
              <div className="container py-4">
                <div className="row justify-content-center">
                  <div className="col">
                    <p className="font-sm font-weight-bold mb-4">Are you sure to Approve the proposal</p>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-auto">
                    <button
                      className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-4 px-4 mr-3"
                      onClick={() => setStatusModalOpen({})}
                      disabled={updating}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
                      disabled={updating}
                      onClick={changeStatus}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1051 }}
      ></div>
    </>
  );
};

export default ProposalApprovalModal;
